@use "../zr-theme/zr-variables.scss" as *;
@use "../zr-theme/functions/fonts" as f;

// local component name
$component: 'zr-rating';

:host {
    display: block;
    margin-bottom: 20px;
}

.#{$component}__summary {
    display: flex;
    justify-content: center;
}

.#{$component}__summary-wrapper {
    padding: 6px 8px;
    border-radius: 20px;
    background: var(--ci-neutral200);
    margin: 0;
    display: flex;
    gap: 8px;
    align-items: center;
}

.#{$component}__average {
    font-size: f.calc-em(18);
    font-weight: 700;
    line-height: 20px;
    color: var(--ci-neutral800);
    margin: 0;
}

// media query for tablet and above
@media only screen and (min-width: $tablet-screen) {
    .#{$component}__summary {
        display: flex;
        margin: 0 auto;
    }
}
